import React, { useState } from 'react';
import { GoogleMap, useJsApiLoader, MarkerF, InfoWindowF } from '@react-google-maps/api';
import CustomMarker from '../img/icons/pinmap.png';

const containerStyle = {
  width: '100%',
  height: '450px'
};

const center = {
  lat: 18.79853927779367,
  lng: 99.03360874531577
};

const darkThemeStyles = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
];

const EventMap = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyAIY7NSZZ67CxFHx7YTZiK5Z-fCWholVR0"
  });

  const [isOpen, setIsOpen] = useState(false);

  return isLoaded ? (
    <div className="w-full mx-auto">
      <div className="overflow-hidden rounded-xl">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={15}
          options={{
            styles: darkThemeStyles,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            mapId: "539cb8811399bc6415afd395",
          }}
        >
          <MarkerF
            position={center}
            onClick={() => setIsOpen(true)}
            icon={{
               url: CustomMarker,
              // Используем проверку window.google для предотвращения ошибок
              scaledSize: window.google ? new window.google.maps.Size(42, 52) : null,
              origin: window.google ? new window.google.maps.Point(0, 0) : null,
              anchor: window.google ? new window.google.maps.Point(20, 40) : null,
            }}
          >
            {/* InfoWindow ДОЛЖЕН быть внутри MarkerF */}
            {isOpen && (
              <InfoWindowF 
                position={center} 
                onCloseClick={() => setIsOpen(false)}
              >
                <div className="p-2 max-w-[200px] text-gray-800">
                  <h3 className="font-bold text-base leading-tight">BLOCK MOUNTAIN 2026</h3>
                  <p className="text-sm mt-1 uppercase tracking-tight font-medium">See you in January 22-25</p>
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${center.lat},${center.lng}`}
                    target="_blank"
                    className="text-blue-600 text-xs font-bold underline mt-2 block"
                    rel="noreferrer"
                  >
                    Get Directions
                  </a>
                </div>
              </InfoWindowF>
            )}
          </MarkerF>
        </GoogleMap>
      </div>
    </div>
  ) : (
    <div className="flex items-center justify-center h-[450px]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
        <p className="text-gray-400 mt-4">Loading Block Mountain Map...</p>
      </div>
    </div>
  );
};

export default React.memo(EventMap);